module.exports = __webpack_public_path__ + "files/11600bd914b1b55db5b49ab3bcf08f08.png";